import React, { useRef } from 'react';
import { ReactComponent as CrownSvg } from '../../../../assets/svg/crown.svg';
import { formatDate } from '../../../../lib/utils';
import ManageSubscriptionDialog from './manageSubscriptionDialog';

const PremiumCard = ({ userInfo, refreshUser }) => {
  const manageSubscriptionRef = useRef(null);

  const openManageSubscription = () => {
    if (manageSubscriptionRef.current) {
      manageSubscriptionRef.current.showModal();
    }
  };

  const closeManageSubscription = () => {
    if (manageSubscriptionRef.current) {
      manageSubscriptionRef.current.close();
    }
  };

  return (
    <>
      <div
        className={`relative overflow-hidden rounded-2xl bg-gradient-to-br from-yellow-500/30 to-yellow-600/20 border border-yellow-500/30 p-4 mt-2 group hover:shadow-lg transition-all duration-300`}
      >
        {/* Decorative elements */}
        {!userInfo.paused && (
          <>
            <div className='absolute top-0 right-0 w-24 h-24 bg-yellow-500/5 rounded-full -translate-y-1/2 translate-x-1/2'></div>
            <div className='absolute bottom-0 left-0 w-32 h-32 bg-yellow-500/5 rounded-full translate-y-1/2 -translate-x-1/2'></div>
          </>
        )}

        {/* Content */}
        <div className='relative z-10'>
          <div className='flex items-center gap-2 mb-3 text-sm'>
            <div className='bg-yellow-500/20 p-1 rounded-lg'>
              <CrownSvg className='size-3 text-yellow-500' />
            </div>
            <div
              className={`font-bold text-yellow-500 ${
                userInfo.paused && 'opacity-50 brightness-90'
              }`}
            >
              Premium Member
            </div>
            {userInfo.paused && <div className='text-xs font-bold'>Paused</div>}
          </div>

          <div
            className={`space-y-1 text-xs text-white ${
              userInfo.paused && 'opacity-50 brightness-90'
            }`}
          >
            <div className='flex items-center gap-2'>
              <div className='w-1.5 h-1.5 rounded-full bg-yellow-500'></div>
              {userInfo.paused ? (
                <span>
                  Paused on{' '}
                  {formatDate(new Date(userInfo.payment[0].updatedAt))}
                </span>
              ) : (
                <span>
                  Activated on{' '}
                  {formatDate(new Date(userInfo.payment[0].activatedAt))}
                </span>
              )}
            </div>

            <div className='flex items-center gap-2'>
              <div className='w-1.5 h-1.5 rounded-full bg-yellow-500'></div>
              <span>Unlimited access to all features</span>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-1.5 h-1.5 rounded-full bg-yellow-500'></div>
              <span>Priority support</span>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-1.5 h-1.5 rounded-full bg-yellow-500'></div>
              <span>Exclusive challenges</span>
            </div>
            <div className='flex items-center gap-2'>
              <div className='w-1.5 h-1.5 rounded-full bg-yellow-500'></div>
              <span>Unlimited AI-powered meal tracking</span>
            </div>
          </div>

          <div className='mt-4 pt-3 border-t border-yellow-500/20'>
            <button
              onClick={openManageSubscription}
              className='text-xs text-yellow-500 hover:text-yellow-600 transition-colors duration-200 flex items-center gap-1 group'
            >
              <span>Manage Subscription</span>
              <svg
                className='w-3 h-3 group-hover:translate-x-0.5 transition-transform duration-200'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M9 5l7 7-7 7'
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <ManageSubscriptionDialog
        dialogRef={manageSubscriptionRef}
        closeDialog={closeManageSubscription}
        userInfo={userInfo}
        refreshUser={refreshUser}
      />
    </>
  );
};

export default PremiumCard;
